import { render, staticRenderFns } from "./SelectAttendances.vue?vue&type=template&id=685d10d7"
import script from "./SelectAttendances.vue?vue&type=script&lang=js"
export * from "./SelectAttendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports